import React, { useState, Fragment } from 'react';
import { useStore } from '../../context/StoreContext';
import { Search, Filter, CreditCard, ShieldCheck, Tag, X, Edit3 } from 'lucide-react';
import { STATUS_META, AdminOrder } from '../../data/adminMockData';
export function AdminOrders() {
  const {
    orders,
    updateOrderStatus,
    updateOrder
  } = useStore();
  const [search, setSearch] = useState('');
  const [selectedOrder, setSelectedOrder] = useState<AdminOrder | null>(null);
  const [showFilters, setShowFilters] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [noteInput, setNoteInput] = useState('');
  const [isEditingNote, setIsEditingNote] = useState(false);
  const filteredOrders = orders.filter(o => {
    const matchesSearch = o.id.toLowerCase().includes(search.toLowerCase()) || o.customer.email.toLowerCase().includes(search.toLowerCase()) || o.customer.lastName.toLowerCase().includes(search.toLowerCase());
    const matchesStatus = statusFilter === 'all' || o.status === statusFilter;
    return matchesSearch && matchesStatus;
  });
  const handleStatusChange = (status: AdminOrder['status']) => {
    if (selectedOrder) {
      updateOrderStatus(selectedOrder.id, status);
      setSelectedOrder({
        ...selectedOrder,
        status
      });
    }
  };
  const handleSaveNote = () => {
    if (selectedOrder) {
      updateOrder(selectedOrder.id, {
        notes: noteInput
      });
      setSelectedOrder({
        ...selectedOrder,
        notes: noteInput
      });
      setIsEditingNote(false);
    }
  };
  return <div className="space-y-6" data-id="element-606">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-607">
        <h1 className="text-2xl font-extrabold text-gray-900" data-id="element-608">Orders</h1>
        <div className="flex items-center gap-3" data-id="element-609">
          <div className="relative" data-id="element-610">
            <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-611" />
            <input type="text" placeholder="Search orders..." value={search} onChange={e => setSearch(e.target.value)} className="pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yarbo-dark focus:border-transparent w-full sm:w-64" data-id="element-612" />
          </div>
          <button onClick={() => setShowFilters(!showFilters)} className={`flex items-center gap-2 px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${showFilters ? 'bg-gray-100 border-gray-400 text-gray-900' : 'border-gray-300 text-gray-700 hover:bg-gray-50 bg-white'}`} data-id="element-613">
            <Filter className="w-4 h-4" data-id="element-614" /> Filter
          </button>
        </div>
      </div>

      {showFilters && <div className="bg-white border border-gray-200 rounded-xl p-4 flex gap-4 items-center" data-id="element-615">
          <div className="flex items-center gap-2" data-id="element-616">
            <label className="text-sm font-medium text-gray-700" data-id="element-617">Status:</label>
            <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="border border-gray-300 rounded-lg text-sm py-1.5 px-3 focus:outline-none focus:ring-2 focus:ring-yarbo-dark" data-id="element-618">
              <option value="all" data-id="element-619">All Statuses</option>
              <option value="pending" data-id="element-620">Pending</option>
              <option value="paid" data-id="element-621">Paid</option>
              <option value="fulfilled" data-id="element-622">Fulfilled</option>
              <option value="shipped" data-id="element-623">Shipped</option>
              <option value="delivered" data-id="element-624">Delivered</option>
              <option value="cancelled" data-id="element-625">Cancelled</option>
              <option value="refunded" data-id="element-626">Refunded</option>
            </select>
          </div>
          {statusFilter !== 'all' && <button onClick={() => setStatusFilter('all')} className="text-sm text-gray-500 hover:text-gray-700 underline" data-id="element-627">
              Clear Filters
            </button>}
        </div>}

      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-628">
        <div className="overflow-x-auto" data-id="element-629">
          <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-630">
            <thead className="bg-gray-50 text-gray-500 font-medium" data-id="element-631">
              <tr data-id="element-632">
                <th className="px-6 py-4" data-id="element-633">Order</th>
                <th className="px-6 py-4" data-id="element-634">Date</th>
                <th className="px-6 py-4" data-id="element-635">Customer</th>
                <th className="px-6 py-4" data-id="element-636">Status</th>
                <th className="px-6 py-4" data-id="element-637">Total</th>
                <th className="px-6 py-4" data-id="element-638">YarboCare</th>
                <th className="px-6 py-4" data-id="element-639"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-640">
              {filteredOrders.map(order => {
              const meta = STATUS_META[order.status];
              const hasProtection = order.items.some(i => i.protection);
              const total = order.subtotalAfterDiscount !== undefined ? order.subtotalAfterDiscount + order.shippingCost + order.tax : order.items.reduce((sum, item) => sum + item.unitPrice * item.qty + (item.protection?.price || 0), 0) + order.shippingCost + order.tax;
              return <tr key={order.id} className="hover:bg-gray-50" data-id="element-641">
                    <td className="px-6 py-4 font-bold text-gray-900" data-id="element-642">
                      {order.id}
                    </td>
                    <td className="px-6 py-4 text-gray-500" data-id="element-643">
                      {new Date(order.placedAt).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4" data-id="element-644">
                      <div className="font-medium text-gray-900" data-id="element-645">
                        {order.customer.firstName} {order.customer.lastName}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-646">
                        {order.customer.email}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-647">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${meta.bg} ${meta.text}`} data-id="element-648">
                        {meta.label}
                      </span>
                    </td>
                    <td className="px-6 py-4 font-medium text-gray-900" data-id="element-649">
                      $
                      {total.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                    </td>
                    <td className="px-6 py-4" data-id="element-650">
                      {hasProtection ? <span className="inline-flex items-center gap-1 text-yarbo-dark font-medium text-xs bg-yarbo-yellow/20 px-2 py-1 rounded" data-id="element-651">
                          <ShieldCheck className="w-3 h-3" data-id="element-652" /> Yes
                        </span> : <span className="text-gray-400 text-xs" data-id="element-653">No</span>}
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-654">
                      <button onClick={() => setSelectedOrder(order)} className="text-yarbo-dark font-bold hover:underline" data-id="element-655">
                        View
                      </button>
                    </td>
                  </tr>;
            })}
              {filteredOrders.length === 0 && <tr data-id="element-656">
                  <td colSpan={7} className="px-6 py-12 text-center text-gray-500" data-id="element-657">
                    No orders found.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Order Detail Modal */}
      {selectedOrder && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-gray-900/50 backdrop-blur-sm" data-id="element-658">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden" data-id="element-659">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50" data-id="element-660">
              <div className="flex items-center gap-4" data-id="element-661">
                <div data-id="element-662">
                  <h2 className="text-xl font-extrabold text-gray-900" data-id="element-663">
                    Order {selectedOrder.id}
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-664">
                    {new Date(selectedOrder.placedAt).toLocaleString()}
                  </p>
                </div>
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${STATUS_META[selectedOrder.status].bg} ${STATUS_META[selectedOrder.status].text}`} data-id="element-665">
                  {STATUS_META[selectedOrder.status].label}
                </span>
              </div>
              <button onClick={() => {
            setSelectedOrder(null);
            setIsEditingNote(false);
          }} className="text-gray-400 hover:text-gray-600" data-id="element-666">
                <X className="w-6 h-6" data-id="element-667" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6" data-id="element-668">
              <div className="flex flex-wrap gap-2 mb-6 pb-6 border-b border-gray-200" data-id="element-669">
                <button onClick={() => handleStatusChange('paid')} className="px-3 py-1.5 text-sm font-medium bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 border border-blue-200" data-id="element-670">
                  Mark Paid
                </button>
                <button onClick={() => handleStatusChange('fulfilled')} className="px-3 py-1.5 text-sm font-medium bg-yellow-50 text-yellow-700 rounded-lg hover:bg-yellow-100 border border-yellow-200" data-id="element-671">
                  Mark Fulfilled
                </button>
                <button onClick={() => handleStatusChange('shipped')} className="px-3 py-1.5 text-sm font-medium bg-purple-50 text-purple-700 rounded-lg hover:bg-purple-100 border border-purple-200" data-id="element-672">
                  Mark Shipped
                </button>
                <button onClick={() => handleStatusChange('delivered')} className="px-3 py-1.5 text-sm font-medium bg-green-50 text-green-700 rounded-lg hover:bg-green-100 border border-green-200" data-id="element-673">
                  Mark Delivered
                </button>
                <button onClick={() => handleStatusChange('cancelled')} className="px-3 py-1.5 text-sm font-medium bg-red-50 text-red-700 rounded-lg hover:bg-red-100 border border-red-200" data-id="element-674">
                  Cancel Order
                </button>
                <button onClick={() => handleStatusChange('refunded')} className="px-3 py-1.5 text-sm font-medium bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 border border-gray-300" data-id="element-675">
                  Refund
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-676">
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-677">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3" data-id="element-678">
                    Customer
                  </h3>
                  <p className="font-medium text-gray-900" data-id="element-679">
                    {selectedOrder.customer.firstName}{' '}
                    {selectedOrder.customer.lastName}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-680">
                    {selectedOrder.customer.email}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-681">
                    {selectedOrder.customer.phone}
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-682">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3" data-id="element-683">
                    Shipping
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-684">
                    {selectedOrder.shipping.line1}
                    <br data-id="element-685" />
                    {selectedOrder.shipping.line2 && <>
                        {selectedOrder.shipping.line2}
                        <br data-id="element-686" />
                      </>}
                    {selectedOrder.shipping.city},{' '}
                    {selectedOrder.shipping.state} {selectedOrder.shipping.zip}
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-687">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3" data-id="element-688">
                    Payment
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-600 mb-2" data-id="element-689">
                    <CreditCard className="w-4 h-4" data-id="element-690" />{' '}
                    {selectedOrder.payment.method} ending in{' '}
                    {selectedOrder.payment.last4}
                  </div>
                  {selectedOrder.discountCode && <div className="flex items-center gap-2 text-sm text-green-600 font-medium" data-id="element-691">
                      <Tag className="w-4 h-4" data-id="element-692" />
                      Code: {selectedOrder.discountCode} (-$
                      {selectedOrder.discountAmount?.toFixed(2)})
                    </div>}
                </div>
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-693">
                Line Items
              </h3>
              <div className="border border-gray-200 rounded-xl overflow-hidden mb-8" data-id="element-694">
                <table className="w-full text-left text-sm" data-id="element-695">
                  <thead className="bg-gray-50 text-gray-500 font-medium" data-id="element-696">
                    <tr data-id="element-697">
                      <th className="px-4 py-3" data-id="element-698">Product</th>
                      <th className="px-4 py-3" data-id="element-699">SKU</th>
                      <th className="px-4 py-3 text-right" data-id="element-700">Price</th>
                      <th className="px-4 py-3 text-right" data-id="element-701">Qty</th>
                      <th className="px-4 py-3 text-right" data-id="element-702">Total</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-703">
                    {selectedOrder.items.map((item, idx) => <tr key={idx} data-id="element-704">
                        <td className="px-4 py-3" data-id="element-705">
                          <div className="font-medium text-gray-900" data-id="element-706">
                            {item.productName}
                          </div>
                          {item.protection && <div className="text-xs text-yarbo-dark mt-1 flex items-center gap-1" data-id="element-707">
                              <ShieldCheck className="w-3 h-3" data-id="element-708" />
                              {item.protection.plan} (+$
                              {item.protection.price})
                            </div>}
                        </td>
                        <td className="px-4 py-3 text-gray-500" data-id="element-709">{item.sku}</td>
                        <td className="px-4 py-3 text-right text-gray-900" data-id="element-710">
                          ${item.unitPrice.toLocaleString()}
                        </td>
                        <td className="px-4 py-3 text-right text-gray-900" data-id="element-711">
                          {item.qty}
                        </td>
                        <td className="px-4 py-3 text-right font-medium text-gray-900" data-id="element-712">
                          $
                          {((item.unitPrice + (item.protection?.price || 0)) * item.qty).toLocaleString()}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>

              <div className="flex justify-end" data-id="element-713">
                <div className="w-64 space-y-3 text-sm" data-id="element-714">
                  <div className="flex justify-between text-gray-500" data-id="element-715">
                    <span data-id="element-716">Subtotal</span>
                    <span data-id="element-717">
                      $
                      {selectedOrder.subtotalBeforeDiscount !== undefined ? selectedOrder.subtotalBeforeDiscount.toLocaleString() : selectedOrder.items.reduce((sum, item) => sum + (item.unitPrice + (item.protection?.price || 0)) * item.qty, 0).toLocaleString()}
                    </span>
                  </div>
                  {selectedOrder.discountAmount && <div className="flex justify-between text-green-600 font-medium" data-id="element-718">
                      <span data-id="element-719">Discount</span>
                      <span data-id="element-720">
                        -${selectedOrder.discountAmount.toLocaleString()}
                      </span>
                    </div>}
                  <div className="flex justify-between text-gray-500" data-id="element-721">
                    <span data-id="element-722">Shipping</span>
                    <span data-id="element-723">
                      {selectedOrder.shippingCost === 0 ? 'Free' : `$${selectedOrder.shippingCost.toLocaleString()}`}
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-500" data-id="element-724">
                    <span data-id="element-725">Tax</span>
                    <span data-id="element-726">${selectedOrder.tax.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between font-bold text-lg text-gray-900 pt-3 border-t border-gray-200" data-id="element-727">
                    <span data-id="element-728">Total</span>
                    <span data-id="element-729">
                      $
                      {(selectedOrder.subtotalAfterDiscount !== undefined ? selectedOrder.subtotalAfterDiscount + selectedOrder.shippingCost + selectedOrder.tax : selectedOrder.items.reduce((sum, item) => sum + (item.unitPrice + (item.protection?.price || 0)) * item.qty, 0) + selectedOrder.shippingCost + selectedOrder.tax).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-8 bg-blue-50 border border-blue-100 p-4 rounded-xl" data-id="element-730">
                <div className="flex items-center justify-between mb-2" data-id="element-731">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-blue-800" data-id="element-732">
                    Admin Notes
                  </h3>
                  {!isEditingNote && <button onClick={() => {
                setNoteInput(selectedOrder.notes || '');
                setIsEditingNote(true);
              }} className="text-blue-600 hover:text-blue-800 text-sm flex items-center gap-1" data-id="element-733">
                      <Edit3 className="w-3 h-3" data-id="element-734" /> Edit
                    </button>}
                </div>
                {isEditingNote ? <div className="space-y-2" data-id="element-735">
                    <textarea value={noteInput} onChange={e => setNoteInput(e.target.value)} className="w-full text-sm p-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" rows={3} placeholder="Add an internal note..." data-id="element-736" />
                    <div className="flex gap-2 justify-end" data-id="element-737">
                      <button onClick={() => setIsEditingNote(false)} className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800" data-id="element-738">
                        Cancel
                      </button>
                      <button onClick={handleSaveNote} className="px-3 py-1 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-739">
                        Save Note
                      </button>
                    </div>
                  </div> : <p className="text-sm text-blue-900 whitespace-pre-wrap" data-id="element-740">
                    {selectedOrder.notes || <span className="text-blue-400 italic" data-id="element-741">
                        No notes added.
                      </span>}
                  </p>}
              </div>
            </div>
          </div>
        </div>}
    </div>;
}